// extracted by mini-css-extract-plugin
module.exports = {"experiences":"ExperienceList_experiences__tgJSC","experience":"ExperienceList_experience__3YVOi"};